<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import AppState, { canView, isRentalsEnabled } from '../states/app'
import CalendarSettingsWizard from './CalendarSettingsWizard.vue'
import SettingsWizard from './SettingsWizard.vue'
const { t } = useI18n()
</script>

<template>
  <div>
    <div
      v-if="!canView"
      class="flex h-[80vh] w-full items-center justify-center text-gray-500"
    >
      {{ t('common.no_access') || 'You do not have access to this module' }}
    </div>
    <SettingsWizard
      v-else-if="
        AppState.isCalendarTypeSplitEnabled ||
        AppState.isServicesEnabled ||
        isRentalsEnabled
      "
    />
    <CalendarSettingsWizard v-else />
  </div>
</template>
